// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   PatientsPage.responsive.css
   Responsive Stylesheet for Patients Directory & Profiles
   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED
   ========================================================================== */

/* ==========================================================================
   IPAD & TABLETS (max-width: 1024px)
   ========================================================================== */
@media (max-width: 1024px) {
  .mgpatients-page {
    width: 100%;
    max-width: 100vw;
    padding: 14px 18px 40px !important;
    overflow-x: hidden;
  }

  .mgpatients-hero {
    grid-template-columns: 1fr !important;
    gap: 22px !important;
    padding: 24px !important;
  }

  .mgpatients-hero h1 {
    font-size: clamp(28px, 4.2vw, 36px) !important;
    line-height: 1.1 !important;
  }

  .mgpatients-body-card {
    max-width: 100% !important;
    padding: 20px !important;
  }

  .mgpatients-model-stage,
  .mgpatients-hra-viewer,
  .mgpatients-hra-canvas {
    height: 350px !important;
    min-height: 350px !important;
  }

  .mgpatients-stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 12px !important;
    margin: 18px 0 !important;
  }

  /* Toolbar fixes */
  .mgpatients-toolbar-wrap .page-toolbar {
    display: flex !important;
    flex-direction: column !important;
    gap: 12px !important;
  }

  .mgpatients-toolbar-wrap .page-toolbar-filters {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 10px !important;
    width: 100% !important;
  }

  .mgpatients-toolbar-wrap .page-toolbar-actions {
    display: flex !important;
    gap: 10px !important;
    width: 100% !important;
    justify-content: flex-end !important;
  }

  .mgpatients-grid,
  .patients-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 14px !important;
  }
}

/* ==========================================================================
   MOBILE PHONES (max-width: 768px)
   ========================================================================== */
@media (max-width: 768px) {
  .mgpatients-page {
    padding: 10px 10px 30px !important;
  }

  .mgpatients-hero {
    padding: 16px 14px !important;
    gap: 16px !important;
    border-radius: 16px !important;
  }

  .mgpatients-hero h1 {
    font-size: 24px !important;
    line-height: 1.15 !important;
  }

  .mgpatients-hero p {
    font-size: 13px !important;
    line-height: 1.5 !important;
    margin: 10px 0 14px !important;
  }

  .mgpatients-actions {
    display: flex !important;
    gap: 8px !important;
    width: 100% !important;
  }

  .mgpatients-actions .mgpatients-btn {
    flex: 1 1 auto !important;
    min-height: 40px !important;
    font-size: 12.5px !important;
  }

  .mgpatients-body-card {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  .mgpatients-body-card-top h3 {
    font-size: 16px !important;
  }

  .mgpatients-model-stage,
  .mgpatients-hra-viewer,
  .mgpatients-hra-canvas,
  .mgpatients-graph-idle {
    height: 260px !important;
    min-height: 260px !important;
    touch-action: pan-y !important;
  }

  .mgpatients-body-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 8px !important;
  }

  .mgpatients-body-metrics > div {
    padding: 10px !important;
  }

  /* Stats grid */
  .mgpatients-stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 6px !important;
    margin: 14px 0 !important;
  }

  .mgpatients-stat-card {
    padding: 10px 8px !important;
    border-radius: 12px !important;
  }

  .mgpatients-stat-card strong {
    font-size: 18px !important;
  }

  .mgpatients-stat-card span {
    font-size: 10px !important;
  }

  .mgpatients-stat-card small {
    display: none !important;
  }

  /* Toolbar stacked on phone */
  .mgpatients-toolbar-wrap {
    margin: 14px 0 !important;
  }

  .mgpatients-toolbar-wrap .page-toolbar-filters {
    grid-template-columns: 1fr !important;
    gap: 8px !important;
  }

  .mgpatients-toolbar-wrap .filter-input,
  .mgpatients-toolbar-wrap .filter-select {
    width: 100% !important;
    min-height: 40px !important;
    font-size: 13.5px !important;
  }

  .mgpatients-toolbar-wrap .page-toolbar-actions {
    display: flex !important;
    gap: 8px !important;
  }

  .mgpatients-toolbar-wrap .page-toolbar-actions .btn {
    flex: 1 1 auto !important;
    min-height: 40px !important;
    font-size: 13px !important;
  }

  /* Single column cards on phone */
  .mgpatients-grid,
  .patients-grid {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
  }

  .patient-card {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  .patient-card-header {
    gap: 10px !important;
  }

  .patient-avatar {
    width: 42px !important;
    height: 42px !important;
    font-size: 13px !important;
  }

  .patient-card-title {
    font-size: 15px !important;
  }

  .patient-meta-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 6px !important;
    margin: 10px 0 !important;
  }

  .patient-card-actions {
    display: flex !important;
    gap: 6px !important;
    margin-top: 10px !important;
  }

  .patient-card-actions .btn {
    flex: 1 1 !important;
    min-height: 34px !important;
    font-size: 12px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PatientsPage.responsive.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;;+EAE+E;AAC/E;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,8CAA8C;IAC9C,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;;;IAGE,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,2DAA2D;IAC3D,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA,kBAAkB;EAClB;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,2DAA2D;IAC3D,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,sBAAsB;IACtB,oCAAoC;EACtC;;EAEA;;IAEE,2DAA2D;IAC3D,oBAAoB;EACtB;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;;IAIE,wBAAwB;IACxB,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,2DAA2D;IAC3D,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,eAAe;EACf;IACE,2DAA2D;IAC3D,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,6BAA6B;EAC7B;IACE,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;;IAEE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA,iCAAiC;EACjC;;IAEE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;IAC3D,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,oBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF","sourcesContent":["/* ==========================================================================\n   PatientsPage.responsive.css\n   Responsive Stylesheet for Patients Directory & Profiles\n   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED\n   ========================================================================== */\n\n/* ==========================================================================\n   IPAD & TABLETS (max-width: 1024px)\n   ========================================================================== */\n@media (max-width: 1024px) {\n  .mgpatients-page {\n    width: 100%;\n    max-width: 100vw;\n    padding: 14px 18px 40px !important;\n    overflow-x: hidden;\n  }\n\n  .mgpatients-hero {\n    grid-template-columns: 1fr !important;\n    gap: 22px !important;\n    padding: 24px !important;\n  }\n\n  .mgpatients-hero h1 {\n    font-size: clamp(28px, 4.2vw, 36px) !important;\n    line-height: 1.1 !important;\n  }\n\n  .mgpatients-body-card {\n    max-width: 100% !important;\n    padding: 20px !important;\n  }\n\n  .mgpatients-model-stage,\n  .mgpatients-hra-viewer,\n  .mgpatients-hra-canvas {\n    height: 350px !important;\n    min-height: 350px !important;\n  }\n\n  .mgpatients-stats-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 12px !important;\n    margin: 18px 0 !important;\n  }\n\n  /* Toolbar fixes */\n  .mgpatients-toolbar-wrap .page-toolbar {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 12px !important;\n  }\n\n  .mgpatients-toolbar-wrap .page-toolbar-filters {\n    display: grid !important;\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 10px !important;\n    width: 100% !important;\n  }\n\n  .mgpatients-toolbar-wrap .page-toolbar-actions {\n    display: flex !important;\n    gap: 10px !important;\n    width: 100% !important;\n    justify-content: flex-end !important;\n  }\n\n  .mgpatients-grid,\n  .patients-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 14px !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE PHONES (max-width: 768px)\n   ========================================================================== */\n@media (max-width: 768px) {\n  .mgpatients-page {\n    padding: 10px 10px 30px !important;\n  }\n\n  .mgpatients-hero {\n    padding: 16px 14px !important;\n    gap: 16px !important;\n    border-radius: 16px !important;\n  }\n\n  .mgpatients-hero h1 {\n    font-size: 24px !important;\n    line-height: 1.15 !important;\n  }\n\n  .mgpatients-hero p {\n    font-size: 13px !important;\n    line-height: 1.5 !important;\n    margin: 10px 0 14px !important;\n  }\n\n  .mgpatients-actions {\n    display: flex !important;\n    gap: 8px !important;\n    width: 100% !important;\n  }\n\n  .mgpatients-actions .mgpatients-btn {\n    flex: 1 1 auto !important;\n    min-height: 40px !important;\n    font-size: 12.5px !important;\n  }\n\n  .mgpatients-body-card {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .mgpatients-body-card-top h3 {\n    font-size: 16px !important;\n  }\n\n  .mgpatients-model-stage,\n  .mgpatients-hra-viewer,\n  .mgpatients-hra-canvas,\n  .mgpatients-graph-idle {\n    height: 260px !important;\n    min-height: 260px !important;\n    touch-action: pan-y !important;\n  }\n\n  .mgpatients-body-metrics {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 8px !important;\n  }\n\n  .mgpatients-body-metrics > div {\n    padding: 10px !important;\n  }\n\n  /* Stats grid */\n  .mgpatients-stats-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 6px !important;\n    margin: 14px 0 !important;\n  }\n\n  .mgpatients-stat-card {\n    padding: 10px 8px !important;\n    border-radius: 12px !important;\n  }\n\n  .mgpatients-stat-card strong {\n    font-size: 18px !important;\n  }\n\n  .mgpatients-stat-card span {\n    font-size: 10px !important;\n  }\n\n  .mgpatients-stat-card small {\n    display: none !important;\n  }\n\n  /* Toolbar stacked on phone */\n  .mgpatients-toolbar-wrap {\n    margin: 14px 0 !important;\n  }\n\n  .mgpatients-toolbar-wrap .page-toolbar-filters {\n    grid-template-columns: 1fr !important;\n    gap: 8px !important;\n  }\n\n  .mgpatients-toolbar-wrap .filter-input,\n  .mgpatients-toolbar-wrap .filter-select {\n    width: 100% !important;\n    min-height: 40px !important;\n    font-size: 13.5px !important;\n  }\n\n  .mgpatients-toolbar-wrap .page-toolbar-actions {\n    display: flex !important;\n    gap: 8px !important;\n  }\n\n  .mgpatients-toolbar-wrap .page-toolbar-actions .btn {\n    flex: 1 1 auto !important;\n    min-height: 40px !important;\n    font-size: 13px !important;\n  }\n\n  /* Single column cards on phone */\n  .mgpatients-grid,\n  .patients-grid {\n    grid-template-columns: 1fr !important;\n    gap: 12px !important;\n  }\n\n  .patient-card {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .patient-card-header {\n    gap: 10px !important;\n  }\n\n  .patient-avatar {\n    width: 42px !important;\n    height: 42px !important;\n    font-size: 13px !important;\n  }\n\n  .patient-card-title {\n    font-size: 15px !important;\n  }\n\n  .patient-meta-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 6px !important;\n    margin: 10px 0 !important;\n  }\n\n  .patient-card-actions {\n    display: flex !important;\n    gap: 6px !important;\n    margin-top: 10px !important;\n  }\n\n  .patient-card-actions .btn {\n    flex: 1 !important;\n    min-height: 34px !important;\n    font-size: 12px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
